import { net_filemanage } from "@/api/http";
export const API_STFMFM02C21 = (...params) =>
net_filemanage.post("/api/STFMFM02C21/CopyFiles", ...params)